'use strict';
import * as $j_app$002ecomponents$002e$002dApp$002dMain$002dModal$0024$002dData from "./app.components.-App-Main-Modal$-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_components_AppMainModal$Data$ClientNewerThanServer(definedAt) {
  this.Lapp_components_AppMainModal$Data$ClientNewerThanServer__f_definedAt = null;
  this.Lapp_components_AppMainModal$Data$ClientNewerThanServer__f_definedAt = definedAt;
}
export { $c_Lapp_components_AppMainModal$Data$ClientNewerThanServer as $c_Lapp_components_AppMainModal$Data$ClientNewerThanServer };
$c_Lapp_components_AppMainModal$Data$ClientNewerThanServer.prototype = new $j_app$002ecomponents$002e$002dApp$002dMain$002dModal$0024$002dData.$h_Lapp_components_AppMainModal$Data();
$c_Lapp_components_AppMainModal$Data$ClientNewerThanServer.prototype.constructor = $c_Lapp_components_AppMainModal$Data$ClientNewerThanServer;
/** @constructor */
function $h_Lapp_components_AppMainModal$Data$ClientNewerThanServer() {
}
export { $h_Lapp_components_AppMainModal$Data$ClientNewerThanServer as $h_Lapp_components_AppMainModal$Data$ClientNewerThanServer };
$h_Lapp_components_AppMainModal$Data$ClientNewerThanServer.prototype = $c_Lapp_components_AppMainModal$Data$ClientNewerThanServer.prototype;
$c_Lapp_components_AppMainModal$Data$ClientNewerThanServer.prototype.hashCode__I = (function() {
  return (-1919779066);
});
$c_Lapp_components_AppMainModal$Data$ClientNewerThanServer.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lapp_components_AppMainModal$Data$ClientNewerThanServer));
});
$c_Lapp_components_AppMainModal$Data$ClientNewerThanServer.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_components_AppMainModal$Data$ClientNewerThanServer.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_components_AppMainModal$Data$ClientNewerThanServer.prototype.productPrefix__T = (function() {
  return "ClientNewerThanServer";
});
$c_Lapp_components_AppMainModal$Data$ClientNewerThanServer.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_components_AppMainModal$Data$ClientNewerThanServer.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_components_AppMainModal$Data$ClientNewerThanServer.prototype.definedAt__Lframework_sourcecode_DefinedAt = (function() {
  return this.Lapp_components_AppMainModal$Data$ClientNewerThanServer__f_definedAt;
});
function $isArrayOf_Lapp_components_AppMainModal$Data$ClientNewerThanServer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_components_AppMainModal$Data$ClientNewerThanServer)));
}
export { $isArrayOf_Lapp_components_AppMainModal$Data$ClientNewerThanServer as $isArrayOf_Lapp_components_AppMainModal$Data$ClientNewerThanServer };
var $d_Lapp_components_AppMainModal$Data$ClientNewerThanServer = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_components_AppMainModal$Data$ClientNewerThanServer, "app.components.AppMainModal$Data$ClientNewerThanServer", ({
  Lapp_components_AppMainModal$Data$ClientNewerThanServer: 1,
  Lapp_components_AppMainModal$Data: 1,
  Lframework_components_FrameworkMainModal$Data: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_components_AppMainModal$Data$ClientNewerThanServer as $d_Lapp_components_AppMainModal$Data$ClientNewerThanServer };
//# sourceMappingURL=app.components.-App-Main-Modal$-Data$-Client-Newer-Than-Server.js.map
